import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@zola/zola-ui';

import DateNoteForm from './DateNoteForm';

import './ChecklistDateNote.less';

class ChecklistDateNote extends Component {
  constructor() {
    super();

    this.state = {
      isEditing: false,
    };
  }

  toggleEditState = (e) => {
    const { isCustomTask, onEditClick } = this.props;

    if (e) e.preventDefault();

    // if the task is custom, trigger change for the mobile modal title
    if (isCustomTask && onEditClick) onEditClick();

    this.setState(prevState => ({ isEditing: !prevState.isEditing }));
  };

  handleOnSubmit = (editTaskRequest) => {
    const { onSubmit, submitCallback } = this.props;

    return onSubmit(editTaskRequest).then(() => {
      this.toggleEditState();
      if (submitCallback) submitCallback();
    });
  };

  renderEditing = () => {
    const { taskId, dueAt, note, title, isCustomTask } = this.props;
    const { isEditing } = this.state;

    if (!isEditing) return null;

    return (
      <div className="checklist__form--date-note__view">
        <span className="checklist__calendar-icon hidden-xs" aria-hidden="true" />
        <DateNoteForm
          onSubmit={this.handleOnSubmit}
          onCancel={this.toggleEditState}
          isCustomTask={isCustomTask}
          initialValues={{ id: taskId, notes: note, due_at: dueAt, title }}
        />
      </div>
    );
  };

  renderNote = () => {
    const { note } = this.props;

    if (!note) {
      return (
        <a href="#" onClick={this.toggleEditState} className="checklist__date--notes checklist__dateNote--addLink">
          Add a note...
        </a>
      );
    }

    return <div className="checklist__date--notes">{note}</div>;
  };

  renderView = () => {
    const { dueAtFormatted } = this.props;
    const { isEditing } = this.state;

    if (isEditing) return null;

    return (
      <div className="checklist__form--date-note__view">
        <span className="checklist__calendar-icon hidden-xs" aria-hidden="true" />
        <div className="checklist__date-note__content">
          <div className="checklist__date-note__content--header">
            <span className="checklist__date--dueAt">Due {dueAtFormatted}</span>
            <IconButton
              iconClassName="zola-ui-icon-pencil"
              onClick={this.toggleEditState}
              className="checklist__date-note--edit-icon"
            />
          </div>
          {this.renderNote()}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="checklist__form--date-note">
        {this.renderEditing()}
        {this.renderView()}
      </div>
    );
  }
}

ChecklistDateNote.propTypes = {
  dueAt: PropTypes.shape({}),
  dueAtFormatted: PropTypes.string,
  note: PropTypes.string,
  onSubmit: PropTypes.func,
  submitCallback: PropTypes.func,
  isCustomTask: PropTypes.bool,
};

ChecklistDateNote.defaultProps = {
  isCustomTask: false,
};

export default ChecklistDateNote;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDateNote/ChecklistDateNote.jsx